import {
  type ICompletenessData,
  selectCompletenessState,
} from 'legacy/lut/features/partner360/completeness'
import { mapJSONToCompleteness } from 'legacy/lut/services/partner360/completeness/mappings/mapJSONToCompleteness'
import { createSelector } from 'reselect'

import { selectCockpitPartnerData } from './selectCockpitPartnerData'

/**
 * Completeness profiles of the cockpit's partner — one entry per offering, with the percentage of
 * each section and the total.
 *
 * Both sources hold the same `Completeness` JSON of the partner's 621 record, but the cockpit's
 * own payload is the one stated for the fiscal year the cockpit stands on, so it comes first. The
 * page's `completeness` slice stands in where the payload carries no profiles at all.
 */
export const selectCockpitPartnerCompleteness = createSelector(
  [selectCockpitPartnerData, selectCompletenessState],
  (partnerData, { data }): ICompletenessData[] => {
    const fromPayload = mapJSONToCompleteness(partnerData[0]?.Completeness ?? '[]')

    return fromPayload.length ? fromPayload : data
  }
)
